// src/Pages/Unauthorized.jsx
import React from 'react';

const Unauthorized = () => {
  return <h1>You are not authorized to access this page.</h1>;
};

export default Unauthorized;
